import { Trans, useTranslation } from 'react-i18next';
import { useLocation, Redirect } from 'react-router';
import { Box, Typography } from 'bonfire-kindling';
import useRegistrationStepperProps from '../../hooks/useRegistrationStepperProps';
import { Stepper, Container } from '../../../components';

const Success = () => {
  const { t } = useTranslation();
  const { state: { email } = {} } = useLocation();
  const stepperProps = useRegistrationStepperProps();
  if (!email) {
    return <Redirect to="/subscribe" />;
  }

  return (
    <Container>
      <Box mt={4}>
        <Stepper {...stepperProps} completeIndex={0} activeIndex={0} />
      </Box>
      <Typography variant="h1" component="h1" style={{ marginTop: '4rem', marginBottom: '1rem' }}>
        {t('subscribe.success.success')}
      </Typography>
      <Typography variant="body2" component="div">
        {t('subscribe.success.one_more_step')}
      </Typography>
      <Box mt={4} bgcolor="blue.light" p={5}>
        <Typography variant="subtitle1" component="h2" gutterBottom>
          {t('subscribe.success.whats_next_header')}
        </Typography>
        <Typography variant="body3">
          <Trans i18nKey="subscribe.success.next_steps" email={email}>
            We&#39;ve sent an email from support@gobonfire.com to
            <strong>{{ email }}</strong>
          </Trans>
        </Typography>
        <Typography variant="body3">{t('subscribe.success.next_steps_check_spam')}</Typography>
        <Typography variant="subtitle1" component="h2" gutterBottom style={{ marginTop: '2rem' }}>
          {t('subscribe.success.step_2_header')}
        </Typography>
        <Typography variant="body3">{t('subscribe.success.email_instructions')}</Typography>
      </Box>
    </Container>
  );
};

export default Success;
